/* Rapport hebdomadaire & journal d’envoi — EM-09 (Bible §50 · MER-104).
   The weekly report reuses the dashboard’s definitions and filters, so two
   numbers never disagree. The log carries the provider lifecycle per send
   — queued → delivered / bounced / complaint / suppressed / retried — each
   with its reason, because a suppressed send is information, not a silence. */
import { Button, EmptyState, ErrorState, KV } from '@/ui'
import { useDelivery } from './api'
import { Chargement, Retour } from './parts'

const MARK = { delivered: '✓', suppressed: '◷', bounced: '◔' } as const
const TONE = { delivered: 'ok', suppressed: 'done', bounced: 'warn' } as const

export default function Journal() {
  const { data, isPending, isError, refetch } = useDelivery()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger le journal d’envoi."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 820 }}>
      <Retour to="/messages?onglet=emails" label="E-mails aux clients" />
      <h2 className="t-page" style={{ margin: 0 }}>Rapport hebdomadaire &amp; journal d’envoi</h2>

      <KV rows={[
        ['Rapport hebdo', `${data.digestWhen} · destinataires : ${data.digestTo}`],
        ['Contenu', data.digestContent],
      ]} />

      {data.sends.length === 0 ? (
        <EmptyState title="Aucun envoi pour l’instant."
          why="Le journal se remplit au premier message parti — chaque ligne portera son état et, s’il n’est pas parti, sa raison." />
      ) : (
        <div className="tablewrap">
          <table className="tbl">
            <thead><tr><th>Envoi</th><th>Classe</th><th>État</th></tr></thead>
            <tbody>
              {data.sends.map(s => (
                <tr key={s.id}>
                  <td>{s.label}</td>
                  <td>{s.classe}</td>
                  <td><span className={'pill pill-' + TONE[s.state]}>{MARK[s.state]} {s.stateLabel}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
